import * as MenuTitleStyles from './MenuTitle.styles';
import DevEnvSwitcher from '../../../DevEnvSwitcher';
import LogoFound from '../../../LogoFound';
import environment from '../../../../utils/environment';

function MenuTitle() {
  const { classes } = MenuTitleStyles.useStyles();

  return (
    <div className={classes.toolbar}>
      <LogoFound dark wordLetterClass={classes.wordLogo} />
      {!environment.isProduction && <DevEnvSwitcher chipClasses={classes.chip} />}
    </div>
  );
}

export default MenuTitle;
